/**
 * 商品カタログID
 */
export const ITEM_CATALOG_ID = {
  /** 電帳標準パック  */
  ED_BASE_PACK: "SFCEBC-205000",
  /** 電帳メンテナンスサービス(BLユーザー) */
  ED_MAINTENANCE_SERVICE_MEMBER: "SFCSPT-210606",
  /** 電帳メンテナンスサービス(非BLユーザー) */
  ED_MAINTENANCE_SERVICE_NON_MEMBER: "SFCSPT-210607",
  /** .c mobileサービス */
  C_MOBILE_SERVICE: "SFCCM-128800",
  /** .c mobile顧客カルテ */
  C_MOBILE_CUSTOMER_KARTE: "SFCCM-128810",
  /** Priceprint.c 標準パック */
  PP_BASE_PACK: "SFCPP-200000",
  /** マーケットプレイス 標準パック */
  MP_BASE_PACK: "SFCMP-206999",
  /** スタートパック */
  START_PACK: "SFCMA-200000",
  /** 組織管理 */
  ORGANIZATION_MANAGEMENT: "SFCCM-126400",
  /** スタンダード保守 */
  STANDARD_MAINTENANCE :"SFCSPT-210601",
  /** CC365+ */
  CC365_PLUS: "SFCSPT-210602",
  /** BroadLeaf Payファクタリングサービスパック（購入事業者） */
  BLPAY_CUSTOMER_PACK: "SFDBP-200100",
  /** BroadLeaf Payファクタリングサービスパック（販売事業者） */
  BLPAY_AFFILIATION_PACK: "SFDBP-200200",
  /** CTI連携サービス（ローカルタイプ：見えTEL君） */
  LOCAL_INTEGRATION_SERVICE: "SFCCM-128010",
  /** POS連携サービス（ローカルタイプ） */
  POS_LINKAGE_SERVICEL_LOCAL: "SFCCM-128600",
  /** 証跡管理サービス */
  EVIDENCE_MANAGEMENT_SERVICE: "SFCCM-129610",
} as const
